import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import PanelHeader from "./common/PanelHeader";
import SummaryBlock from "./common/SummaryBlock";
import ListItemCard from "./common/ListItemCard";
import ActionButtonRow from "./common/ActionButtonRow";

export default function UpcomingPaymentsPanel({ summaryItems = [], payments = [], buttons = [], paymentSummaryByBank = [] }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        p: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.default",
      }}
    >
      <PanelHeader
        title="Upcoming Payments"
        subtitle="All credit card payments across institutions"
        statusChip={<Chip label="1 overdue" color="error" size="small" />}
      />
      <SummaryBlock items={summaryItems} columns={2} />
      {paymentSummaryByBank.length > 0 && (
        <Box>
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
            Payment Summary by Bank (Alphabetical)
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {paymentSummaryByBank.map((item, idx) => (
              <Box key={idx} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", bgcolor: "background.paper", borderRadius: 2, border: "1px solid", borderColor: "divider", p: 1 }}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">{item.bank}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.payments} payments • {item.autopay} on autopay
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "right" }}>
                  <Typography variant="h6" fontWeight="bold">${item.amount.toLocaleString()}</Typography>
                  <Typography variant="body2" color="text.secondary">{item.ratio}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2 }}>
        Payment Schedule
      </Typography>
      {payments.map((p, idx) => (
        <ListItemCard key={idx} {...p} />
      ))}
      <ActionButtonRow buttons={buttons} />
    </Box>
  );
}
